import { defineStore } from 'pinia'

import { api, mock } from '@/services'
import versionTypes from '@/constants/versionTypes'

export const useVersionStore = defineStore('version', {
    state: () => {
        return {
            loaded: false,
            version: {},
        }
    },
    getters: {
        dataModeForTheme(state) {
            switch (state.version.theme) {
                case 'dark':
                    return 'brand-invert'
                case 'light':
                default:
                    return 'brand'
            }
        },
        isNextGen(state) {
            return state.version.type === versionTypes.nextGen
        },
    },
    actions: {
        // Initial loading of the dashboard
        async load() {
            const { appId } = useAppStore()

            // If mocking use the mock version
            if (mock.mocking()) {
                this.version = mock.version()
                this.loaded = true
                return
            }

            return api.get(`/${appId}/versions`)
                .then(({ data }) => {
                    this.version = data
                    this.loaded = true
                })
        },
    },
})
